import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';

const styles = {
  segmentContainer: {
    display: 'flex',
    marginY: '10px',
  },
  profileContainer: {
    padding: '16px',
    paddingTop: 0,
  },
  button: {
    padding: 0,
    width: '100%',
  },
  buttonLabel: {
    color: 'grey.500',
    fontSize: 16,
    fontWeight: '500',
  },
  selectedButton: {
    color: 'primary.main',
  },
  divider: {
    width: 2,
    flex: 1,
    border: '1px solid',
    borderColor: 'common.border',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
